import MoveManger from "../../../../gd/manager/move-manager"
import Document from "../../../../model2/doc/document"
import ProjectSession from "../../../../model2/project/project-session"

type ModalMoveTo_commitParams = {
    documentToMove        : Document
    targetProject   : ProjectSession
}

export default function ModalMoveTo_commitDocumentMoveToFolder(params: ModalMoveTo_commitParams, onMoveCallback?: {(selectedProjectId?: ID): void} ) {
    const documentUsers = gd.session.projects.get(params.documentToMove.projectId)!.userIds()

    MoveManger.moveNoteToProject(params.documentToMove.id, params.targetProject.id, documentUsers, () => {
        onMoveCallback?.()
        gd.modal.hide()
    })
}